import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./RulesInformations.module.sass";
import Card from "../../../../components/Card";
import Editor from "../../../../components/Editor";
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';

const RulesInformations = ({ className, partner, onPartnerChange }) => {
    const [editorState, setEditorState] = useState(() => {
        // Initialiser l'EditorState avec le contenu existant ou vide
        if (partner?.internal_rules) {
            try {
                const blocksFromHTML = convertFromHTML(partner.internal_rules);
                const contentState = ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap
                );
                return EditorState.createWithContent(contentState);
            } catch (error) {
                console.error('Erreur lors de la conversion HTML vers EditorState:', error);
                return EditorState.createEmpty();
            }
        }
        return EditorState.createEmpty();
    });

    // Mettre à jour l'EditorState quand les données du partenaire changent
    useEffect(() => {
        if (partner?.internal_rules) {
            try {
                const blocksFromHTML = convertFromHTML(partner.internal_rules);
                const contentState = ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap
                );
                setEditorState(EditorState.createWithContent(contentState));
            } catch (error) {
                console.error('Erreur lors de la mise à jour de l\'EditorState:', error);
            }
        }
    }, [partner?.internal_rules]);

    // Fonction simple pour convertir le contenu Draft.js en HTML
    const convertContentToHtml = (contentState) => {
        const rawContent = convertToRaw(contentState);
        let html = '';
        
        rawContent.blocks.forEach(block => {
            const text = block.text;
            const type = block.type;
            
            // Appliquer les styles inline
            let styledText = text;
            if (block.inlineStyleRanges && block.inlineStyleRanges.length > 0) {
                // Traitement basique des styles (gras, italique, souligné)
                block.inlineStyleRanges.forEach(styleRange => {
                    const { offset, length, style } = styleRange;
                    const before = styledText.substring(0, offset);
                    const styled = styledText.substring(offset, offset + length);
                    const after = styledText.substring(offset + length);
                    
                    if (style === 'BOLD') {
                        styledText = before + `<strong>${styled}</strong>` + after;
                    } else if (style === 'ITALIC') {
                        styledText = before + `<em>${styled}</em>` + after;
                    } else if (style === 'UNDERLINE') {
                        styledText = before + `<u>${styled}</u>` + after;
                    }
                });
            }
            
            // Appliquer les types de blocs
            if (type === 'unordered-list-item') {
                html += `<li>${styledText}</li>`;
            } else if (type === 'header-one') {
                html += `<h1>${styledText}</h1>`;
            } else if (type === 'header-two') {
                html += `<h2>${styledText}</h2>`;
            } else {
                html += `<p>${styledText}</p>`;
            }
        });
        
        return html;
    };

    const handleEditorChange = (newEditorState) => {
        setEditorState(newEditorState);
        
        // Convertir l'EditorState en HTML
        const contentState = newEditorState.getCurrentContent();
        const htmlContent = convertContentToHtml(contentState);
        
        // Simuler un événement pour être compatible avec onPartnerChange
        const event = {
            target: {
                name: 'internal_rules',
                value: htmlContent
            }
        };
        onPartnerChange(event);
    };

    return (
        <Card
            className={cn(styles.card, className)}
            title="Règlement intérieur"
            classTitle="title-red"
        >
            <Editor
                state={editorState}
                onChange={handleEditorChange}
                classEditor={styles.editor}
                label="Règlement intérieur :"
            />
        </Card>
    );
};

export default RulesInformations;
